module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Over mountains to inns")]), _c('br'), _vm._v("Traveling in the Europe of five hundred years ago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The banker’s road"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Florence to Bruges")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Furs"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Lübeck to Novgorod")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The pilgrim’s shell"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Vézelay to Santiago de Compostela")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The armor merchant"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Milan to Mont-Saint-Michel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The painter"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Nuremberg to Venice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7#pt7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jubilee"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Trondheim to Rome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8#pt8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The archer of the king of France"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Edinburgh to Paris")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9#pt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The door to Asia"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Genoa to Istanbul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10#pt10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The shipbuilder"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Seville to Antwerp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11#pt11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ambassador"), _c('br'), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("From Vienna to Moscow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chr#chr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliographical notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographic Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0